module.exports = __webpack_public_path__ + "img/infinity8_icon.34e9d8c6.png";